<template>
  <v-container fluid>
    <v-card v-if="user && user.id">
      <v-card-title>
        Reset Password
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
        <v-text-field
          tabindex="0"
          v-model="currentPassword"
          v-if="isLoggedIn"
          type="password"
          label="Current Password"
          :rules="[rules.required]"
        ></v-text-field>
        <div class="text-subtitle-1" v-else>
          Welcome {{ user.firstName }} {{ user.lastName }}, please reset your
          password for {{ user.accountName }}.
        </div>
        <v-text-field
          tabindex="1"
          :rules="passwordRules"
          v-model="password"
          label="New Password"
          :append-icon="showPass1 ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="() => (showPass1 = !showPass1)"
          :type="showPass1 ? 'text' : 'password'"
        ></v-text-field>
        <v-text-field
          tabindex="2"
          :rules="passwordConfirmRule"
          v-model="confirmPassword"
          label="Confirm New Password"
          :append-icon="showPass2 ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="() => (showPass2 = !showPass2)"
          :type="showPass2 ? 'text' : 'password'"
        ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          tabindex="3"
          color="primary"
          class="mb-5"
          :disabled="isAppLoading"
          @click="resetPassword()"
          >Update</v-btn
        >
        <v-spacer />
      </v-card-actions>
    </v-card>
    <div v-else-if="loaded">
      <unauthorized />
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Unauthorized from "@/components/error/Unauthorized.vue";
import { rules } from "@/store/util/rules.js";

export default {
  components: { Unauthorized },
  data() {
    return {
      loaded: false,
      userToken: null,
      currentPassword: "",
      password: "",
      confirmPassword: "",
      user: null,
      showPass1: false,
      showPass2: false,
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 6) || "Passowrd must be at least 6 characters"
      ],
      passwordConfirmRule: [
        () => this.password === this.confirmPassword || "Password must match"
      ],
      rules
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser"]),
    ...mapGetters("navigation", ["isAppLoading", "globalCenter"])
  },
  mounted() {
    // check user, either authenticated or through token
    if (this.isLoggedIn && this.currentUser) {
      this.user = this.currentUser;
      this.user.id = this.currentUser.uId;
      this.user.accountId = this.globalCenter.accountId;
      console.log("user", this.user);
    } else {
      this.userToken = this.$route.query.token;
      this.getUserWithToken(this.userToken).then(result => {
        this.user = result;
        this.loaded = true;
        console.log("user: ", this.user);
      });
    }
  },
  methods: {
    ...mapActions('messages', ['addMessage', 'addErrorMessage']),
    async getUserWithToken(token) {
      if (!token) {
        return null;
      }

      const params = {
        token
      };
      return await this.$axios
        .get("/public/user/user-by-token", { params })
        .then(resp => {
          const user = resp.data;
          return user;
        })
        .catch(() => {
          return null;
        });
    },
    resetPassword() {
      if (!this.$refs.form.validate()) {
        this.addErrorMessage("Please check your inputs");
        return;
      }

      if (this.userToken) {
        this.resetPwdWithToken();
      } else {
        this.authenticatedPwdReset();
      }
    },
    resetPwdWithToken() {
      const resetData = {
        token: this.userToken,
        confirmPassword: this.confirmPassword,
        currentPassword: this.currentPassword,
        password: this.password
      };

      this.$axios
        .post("/public/user/resetpwd", resetData)
        .then(resp => {
          const customerName = resp.data.firstname;
          this.addMessage(`${customerName}, your password has changed`)
          this.$router.push({
            name: "Login",
            query: { account: this.user.accountId }
          });
        })
        .catch(error => {
          const message = error.data.message || "Error resetting your password";
          this.addErrorMessage(message);
        });
    },
    authenticatedPwdReset() {
      const data = {
        confirmPassword: this.confirmPassword,
        currentPassword: this.currentPassword,
        password: this.password
      };

      this.$axios
        .post("/user/reset-password", data)
        .then(resp => {
          const customerName = resp.data.firstName;
          this.addMessage(`${customerName}, your password has changed`);
          this.$router.push("/");
        })
        .catch(error => {
          const message = error.data.message || "Error resetting your password";
          this.addErrorMessage(message);
        });
    }
  }
};
</script>

<style></style>
